module.exports = __webpack_public_path__ + "img/napoli.88d00c90.svg";